import "./App.css";
import { AuthProvider } from "./config/AuthContext";
import AppRoutes from "./config/routes";
export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
